import TakingOrderTable from "./component/TakingOrderTable";

function TakingOrderNew() {

  return (
    <>
      <TakingOrderTable status={1} nextStatus={2} hasAction/>
    </>
  );
}

export default TakingOrderNew;
